
import { apiRequest } from '../../apiCall'

export const getSecretaryInfo = () => apiRequest('Dashboard.SecratryInfoService');

export const getIvrInfo = () => apiRequest('Dashboard.IvrInfoService');

export const getFaxInfo = () => apiRequest('Dashboard.FaxInfoService');

export const getDashboardData = () => apiRequest('Dashboard.DashboardData', {}, '', true);

export const getLatestCustomerCalls = () => apiRequest('Dashboard.GetLatestCustomerCalls', {}, '', false);

export const getFreeSecretaryPackageRequest = () => apiRequest('product.getFreeSecretaryProduct');

export const getFreeIvrPackageRequest = () => apiRequest('product.getFreeIvrProduct');

export const getCreditDetails=(params)=>apiRequest('CreditDetails.GetCreditDetails',{},`?type=${params?.type}&fromDate=${params?.fromDate}&toDate=${params?.toDate}`)
    




